/**
 * URL segments of the order drawer family. Kept apart from `orderDrawerRoutes.ts`, which imports
 * the routed containers, so the containers can read these without an import cycle.
 */
export const ORDER_DRAWER_SEGMENT = "order";
export const APPROVAL_DRAWER_SEGMENT = "approval";
export const INVOICE_DRAWER_SEGMENT = "invoice";
export const PRODUCT_DRAWER_SEGMENT = "product";
export const TRACKING_DRAWER_SEGMENT = "tracking";
export const INTEGRATION_TRANSFER_DRAWER_SEGMENT = "integration-transfer";

export const ORDER_DRAWER_TABS = ["shipments", "products"] as const;
export type OrderDrawerRouteTab = (typeof ORDER_DRAWER_TABS)[number];
export const ORDER_DRAWER_DEFAULT_TAB: OrderDrawerRouteTab = "shipments";

export const PRODUCT_DRAWER_TABS = ["details", "stock"] as const;
export type ProductDrawerRouteTab = (typeof PRODUCT_DRAWER_TABS)[number];
export const PRODUCT_DRAWER_DEFAULT_TAB: ProductDrawerRouteTab = "details";
